import React, { Component }            from 'react';
import { Popover, OverlayTrigger, 
         Tooltip }                     from 'react-bootstrap';
import { ClipLoader }                  from 'react-spinners';
import { LocalForm }                   from 'react-redux-form';
import { FaQuestionCircle }            from 'react-icons/fa';
import { FaStar }                      from 'react-icons/fa';
import { MdSkipNext }                  from 'react-icons/md';
import { MdArrowForward }              from 'react-icons/md';
import { MdArrowBack }                 from 'react-icons/md';
import { MdGroupAdd }                  from 'react-icons/md';
import { MdAddCircle }                 from 'react-icons/md';
import { MdRemoveCircle }              from 'react-icons/md';
import { MdError }                     from 'react-icons/md';
import { withRouter }                  from 'react-router';
import { connect }                     from 'react-redux';
import PubSub                          from 'pubsub-js';
import Questions                       from '../Questions';
import { EmployeeOnboardingConstants } from '../../environment';
import uuidv4                          from '../../../../../utils/Uuid';
import { addFetchData }                from '../../../../../actions/employee-onboarding/add';
import { skipFetchData}                from '../../../../../actions/employee-onboarding/skip';
import { groupsFetchData}              from '../../../../../actions/employee-onboarding/groups';
import { directFetchData}              from '../../../../../actions/employee-onboarding/direct';

var apiHost = EmployeeOnboardingConstants.WebApiHost;

class AddItem extends Component {
    
  constructor(props) {
    super(props);
    this.state = {
      employee          : '',
      employeeOriginal  : '',
      employeeValid     : true,
      equivalent        : '',
      equivalentOriginal: '',
      equivalentValid   : true,
      requestor         : '',
      requestorOriginal : '',
      requestorValid    : true,
      sr                : '',
      srOriginal        : '',
      srValid           : true,
      srValidMessage    : '',
      showAdd           : false,
      readonly          : false,
      noGroups          : false,
      errorGroups       : false,
      groups            : [],
      options           : [],
      questions         : [],
      directGroups      : [],
      directGroupsValid : {},
      type              : 'equivalent',
      item              : this.props.item,
      key               : this.props.key,
      eventKey          : this.props.eventKey
    };

    this.handleSubmit      = this.handleSubmit.bind(this);
    this.typeChange        = this.typeChange.bind(this);
    this.updateEmployee    = this.updateEmployee.bind(this);
    this.updateEquivalent  = this.updateEquivalent.bind(this);
    this.updateRequestor   = this.updateRequestor.bind(this);
    this.updateSr          = this.updateSr.bind(this);
    this.updateDirectGroup = this.updateDirectGroup.bind(this);
    this.validateForm      = this.validateForm.bind(this);
    this.params            = this.params.bind(this);
    this.equivalent        = this.equivalent.bind(this);
    this.groups            = this.groups.bind(this);
    this.reset             = this.reset.bind(this);
    this.skip              = this.skip.bind(this);
    this.checked           = this.checked.bind(this);
    this.addDirectGroup    = this.addDirectGroup.bind(this); 
    this.removeDirectGroup = this.removeDirectGroup.bind(this);
  }
  
  subscriber(msg, result) {
    if (result === null) {
      this.reset();
    }
    else {
      if (result.make_like_groups) {
        this.setState(
          { groups: result.make_like_groups, 
            noGroups: false,
            showAdd: true
          }
        );
      }
      else {
        this.setState(
          { groups: [],
            noGroups: true,
            showAdd: false
          }
        );
      }
    }
  }

  componentDidMount() {
    this.reset();
    if (this.state.item) {
      var item       = this.state.item;
      var responses  = item.responses;
      var employee   = '';
      var equivalent = '';
      for (var i = 0; i < responses.length; i++) {
        var question = item.responses[i];
        if (question.is_employee) {
          employee = question.answer;
        }

        if (question.is_equivalent) {
          equivalent = question.answer;
        }
      }

      this.setState(
      {
        questions          : item.responses, 
        employee           : employee, 
        equivalent         : equivalent, 
        employeeOriginal   : employee, 
        equivalentOriginal : equivalent,
        sr                 : item.id,
        srOriginal         : item.id,
        requestor          : item.requestor,
        requestorOriginal  : item.requestor,
        readonly           : true
      });
    }
    
    this.token = PubSub.subscribe('employee.add.groups', this.subscriber.bind(this));
  }
  
  componentWillUnmount(){
    PubSub.unsubscribe(this.token);
  }

  add() {
    var params = this.params();
    this.props.fetchDataAdd(apiHost, params);
  }
  
  skip() {
    var params = this.params();
    this.props.fetchDataSkip(apiHost, params);
  }

  equivalent(event) {
    if (this.validateForm()) {
      this.setState({ noGroups: false, errorGroups: false }, function() {
        var params = this.params();
        if (this.state.type === 'equivalent') {
          this.props.fetchDataGroups(apiHost, params);
        }
        else if (this.state.type === 'direct') {
          this.props.fetchDataDirect(apiHost, params);
        }
      });
    }

    event.preventDefault();
  }
  
  groups(event) {
    if (this.validateForm()) {
      this.setState({ noGroups: false, errorGroups: false }, function() {
        var params = this.params();
        this.props.fetchDataDirect(apiHost, params);
      });
    }

    event.preventDefault();
  }

  reset() {
    this.setState(
    {
      employee          : this.state.employeeOriginal, 
      employeeValid     : true, 
      equivalent        : this.state.equivalentOriginal, 
      equivalentValid   : true, 
      sr                : this.state.srOriginal,
      srValid           : true,
      requestor         : this.state.requestorOriginal,
      requestorValid    : true,
      showAdd           : false,
      noGroups          : false,
      errorGroups       : false,
      groups            : [],
      directGroups      : {} 
    }, function() {
       this.addDirectGroup();
    });
  }
  
  addDirectGroup() {
    var name = "direct-" + uuidv4();
    let direct = Object.assign({}, this.state.directGroups);
    var first  = Object.keys(direct).length < 1;
    direct[name] = {
      name  : name,
      text  : '',
      valid : false,
      first : first
    };
    
    this.setState({
      directGroups: direct
    })
  }
  
  removeDirectGroup(name) {
    let direct = Object.assign({}, this.state.directGroups);
    delete direct[name];
    this.setState({
      directGroups: direct
    })
  }

  params() {
    var that    = this;
    var options = this.state.options;
    
    if (this.state.type === 'direct') {
      var list = [];
      Object.keys(that.state.directGroups).forEach(function(key) { 
        var value = that.state.directGroups[key];
        list.push({name: value.text});
      });
      
      options = list;
    }
    
    var params = {
      requestor:       this.state.requestor,
      new_employee:    this.state.employee,
      make_like:       this.state.equivalent,
      sr:              this.state.sr,
      group_overrides: options
    };

    return params;
  }

  updateEmployee(event) {
    this.setState({ employee: event.target.value }, function() {
      this.validateForm();
    });
  }

  updateEquivalent(event) {
    this.setState({ equivalent: event.target.value }, function() {
      this.validateForm();
    });
  }

  updateSr(event) {
    this.setState({ sr: event.target.value }, function() {
      this.validateForm();
    });
  }

  updateRequestor(event) {
    this.setState({ requestor: event.target.value }, function() {
      this.validateForm();
    });
  }

  updateCheckbox(event) {
    const options = this.state.options

    if (event.target.checked) {
      options.push({name: event.target.name})
    } else {
      var index = options.map(e => e.name).indexOf(event.target.name)
      options.splice(index, 1)
    }

    this.setState({ options: options })
  }
  
  updateDirectGroup(event) {
    let direct = Object.assign({}, this.state.directGroups);
    if (direct.hasOwnProperty(event.target.name)) {
      direct[event.target.name].text = event.target.value;
      this.setState({ directGroups: direct }, function() {
        this.validateForm();
      });
    }
  }
  
  handleSubmit(event) {
    if (this.validateForm()) {
      this.add();
    }
  }
  
  typeChange(event) {
    this.setState({ type: event.target.value }, function() {
      this.reset();
    });
  }
  
  selectAll() {
    var boxes = document.getElementById("checkboxGroups").getElementsByTagName("input"); 
    for (var i = 0; i < boxes.length; i++) {
      var b     = boxes[i]
      b.checked = !b.checked;
      this.updateCheckbox({
        target: {
          name    : b.name,
          checked : b.checked
        }
      });
    }
  }
  
  checked(name) {
    return this.state.options.some(e => e.name === name);
  }

  validateForm() {
    var valid = true;
    if (!this.state.employee) {
      this.setState({ employeeValid: false });
      valid = false;
    } else {
      this.setState({ employeeValid: true });
    }

    if (this.state.type === 'equivalent') {
      if (!this.state.equivalent) {
        this.setState({ equivalentValid: false });
        valid = false;
      } else {
        this.setState({ equivalentValid: true });
      }
    }
    else {
      let direct = Object.assign({}, this.state.directGroups);
      Object.keys(direct).forEach(function(key) { 
        var value = direct[key];
        if (value.text) {
          value.valid = true;
        }
        else {
          value.valid = false;
          valid = false;
        }
      });
      
      this.setState({ directGroups: direct });
    }
   
    if (!this.state.readonly) {
      if (!this.state.sr) {
        this.setState({ srValid: false });
        valid = false;
      }
      else if (this.state.sr.toLowerCase().startsWith('dr') || this.state.sr.toLowerCase().startsWith('gr')) {
        this.setState({ srValid: false, srValidMessage: 'Ticket must not start with DR (Door Request) or GR (Group Request)' });
        valid = false;
      } else {
        this.setState({ srValid: true, srValidMessage: '' });
      }

      if (!this.state.requestor) {
        this.setState({ requestorValid: false });
        valid = false;
      } else {
        this.setState({ requestorValid: true });
      }
    }

    return valid;
  }
  
  render() { 
    let groups = null;
    var that   = this;
    if (this.state.groups && this.state.groups.length > 0) {
      var items = [];
      for (var j = 0; j < this.state.groups.length; j++) {
        var item = this.state.groups[j];
        const tooltip = (
          <Popover
            id={item.name}
            placement='right'
            positionLeft={200}
            positionTop={50}
            title='Group'
          >
            <strong>{item.name}</strong>
          </Popover>
        );
        items.push(
          <li className='list-group-item' key={j} style={{fontSize: '14px'}}>
            <OverlayTrigger placement='top' overlay={tooltip}>
                <button className='break-word'>{item.name.split(',')[0].split('=')[1]}</button>
            </OverlayTrigger>
            { item.already_in_group ?
              <span style={{marginLeft: '5px'}} >
                <FaStar color='yellow' style={{ stroke: 'black', strokeWidth: '2px' }} />
              </span>
              : 
              <span />
            }
            <div>
              <div><b>Manager: </b>{item.manager}</div>
              <b>Description: </b>{item.description}
              <div className='pull-right'>
                <input checked={this.checked(item.name)} name={item.name} type='checkbox' onChange={this.updateCheckbox.bind(this)} />
                <label className='label-primary' />
              </div>
            </div>
          </li>
        );
      }

      groups =
        <div>
          <div className='panel-heading'>
            <b style={{ marginLeft: '7px' }}>Equivalent User Groups</b>
            <input name='select-all' style={{marginTop: '10px', float: 'right'}} type='checkbox' onChange={this.selectAll.bind(this)} />
          </div>
          <ul className='list-group' id='checkboxGroups'>
            {items}
          </ul>
        </div>;
    }
    
    let ttr  = <Tooltip className="fixZIndex" id={uuidv4()}>Enter a cname (busterbronco)</Tooltip>
    let tte  = <Tooltip className="fixZIndex" id={uuidv4()}>Enter an employee ID (111111111)</Tooltip>;
    let ttd  = <Tooltip className="fixZIndex" id={uuidv4()}>Enter a cname (Access Control Assistance Operators)</Tooltip>;
    let skip = null;
    
    if (this.state.readonly) {
      skip = this.props.skipIsLoading ?
        <div style={{position: 'absolute', right: '10px'}}>
          <ClipLoader
            color={'#072659'}
            loading={this.props.skipIsLoading}
          />
        </div>
        : 
        <button title='Skip' style={{position: 'absolute', right: '30px'}} onClick={this.skip}>
          <MdSkipNext size={32} />
        </button>;
    }
    
    let questions = null;
    if (this.state.questions.length > 0 && this.state.readonly) {
      questions = <Questions item={this.state.questions} />;
    }
    
    let form = 
      <LocalForm onSubmit={(values) => this.handleSubmit(values)} style={{marginLeft: '20px'}}>
        <div style={{float: 'left', clear: 'both'}}>
          <div className='block'>
            <label>
              Type &nbsp;
            </label>
            <select onChange={this.typeChange}>
              <option value="equivalent">Equivalent</option>
              <option value="direct">Direct Add</option>
            </select>
          </div>
          <div className='block' style={{clear: 'both'}}>
            <label>
              SR # &nbsp; 
            </label>
            <div style={{float: 'right'}}>
              { this.state.readonly ?
                <span>{this.state.sr.toUpperCase()}</span>
                :
                <input value={this.state.sr} className={this.state.srValid ? '' : 'invalid'} type='text' onChange={this.updateSr} />
              }
              {
                this.state.srValidMessage ?
                <div style={{clear: 'both', color: 'red'}}>{this.state.srValidMessage}</div>
                :
                <div></div>
              }
            </div>
            {skip}
          </div>
          <div className='block' style={{clear: 'both'}}>
            { this.state.readonly ?
              <div>
                <label>
                  Requestor &nbsp;
                </label>
                <span style={{float: 'right'}}>{this.state.requestor ? this.state.requestor.toLowerCase() : 'unknown'}</span>
              </div>
              :
              <div>
                <label>
                  Requestor &nbsp;
                  <OverlayTrigger placement='top' overlay={ttr}>
                    <FaQuestionCircle />
                  </OverlayTrigger>
                </label>
                <input style={{float: 'right'}} value={this.state.requestor} className={this.state.requestorValid ? '' : 'invalid'} type='text' onChange={this.updateRequestor} />
              </div>
            }
          </div>
          <div className='block' style={{clear: 'both'}}>
            <label>
              Employee ID &nbsp;
              <OverlayTrigger placement='top' overlay={tte}>
                <FaQuestionCircle />
              </OverlayTrigger>
              &nbsp;
            </label>
            <input style={{float: 'right'}} value={this.state.employee} className={this.state.employeeValid ? '' : 'invalid'} type='text' onChange={this.updateEmployee} />
          </div>
          { this.state.type === 'equivalent' ?
            <div className='block' style={{clear: 'both'}}>
              <label>
                Equivalent ID
                <OverlayTrigger placement='top' overlay={tte}>
                  <FaQuestionCircle style={{marginLeft: '3px'}} />
                </OverlayTrigger>
                &nbsp;
              </label>
              <div style={{float: 'right'}}>
                <input value={this.state.equivalent} className={this.state.equivalentValid ? '' : 'invalid'} type='text' onChange={this.updateEquivalent} />
                {
                  this.props.groupsHasErrored ?
                  <div style={{color: 'red'}}>Please check your user IDs</div>
                  :
                  <span></span>             
                }
              </div>
            </div>
           :
           <div className='block' style={{clear: 'both'}}>
              <label>
               Groups
               <OverlayTrigger placement='top' overlay={ttd}>
                 <FaQuestionCircle style={{marginLeft: '3px'}} />
               </OverlayTrigger>
               &nbsp;
              </label>
             {Object.keys(this.state.directGroups).map(function(key) {
                return (
                  <div style={{clear: 'both'}} key={that.state.directGroups[key].name}>
                    { !that.state.directGroups[key].first ?
                      <label>
                        <button onClick={() => that.removeDirectGroup(that.state.directGroups[key].name)}>
                          <MdRemoveCircle color='red' size={20} />
                        </button>
                      </label>
                      :
                      <span>&nbsp;</span>
                    }
                    <input style={{float: 'right'}} type='text' className={that.state.directGroups[key].valid ? '' : 'invalid'} name={that.state.directGroups[key].name} onChange={that.updateDirectGroup} key={that.state.directGroups[key].name} />
                  </div>
                )
             })}
             <button style={{float: 'right', marginTop: '5px', clear: 'both'}} onClick={this.addDirectGroup}>
               <MdAddCircle size={24} />
             </button>
           </div>
          }
        </div>
        <div style={{float: 'left', clear: 'both', marginTop: '20px'}}>
          {groups}
          { this.state.noGroups ?
            <div className='panel-heading'><b style={{ marginLeft: '7px' }}>No Matching Equivalent Groups</b></div>
            :
            <span />
          }            
        </div>
        <div style={{clear: 'both', marginLeft: '10px'}}>
          { this.props.groupsIsLoading ?
            <ClipLoader
              color={'#072659'}
              loading={this.props.groupsIsLoading}
            />
            : <div>
              </div>
          }
          { this.props.addIsLoading ?
            <ClipLoader
              color={'#072659'}
              loading={this.props.addIsLoading}
            />
            : <div>
              </div>
          }
          { this.props.directIsLoading ?
            <ClipLoader
              color={'#072659'}
              loading={this.props.directIsLoading}
            />
            : <div>
              </div>
          }
          { this.props.groupsIsLoading || this.props.addIsLoading || this.props.directIsLoading ?
            <span>
            </span>
            : <div>
                <button title='Reset' className='btn-right' onClick={this.reset} style={{marginRight: '20px'}}>
                  <MdArrowBack size={32} />
                </button>
                <button title='Next' className={this.state.showAdd ? 'hidden' : ''} onClick={this.equivalent}>
                  <MdArrowForward size={32} />
                </button>
                <button title='Add' className={this.state.showAdd ? '' : 'hidden'} onClick={this.handleSubmit}>
                  <MdGroupAdd size={32} />
                </button>
                { !this.props.groupsIsLoading && !this.props.addIsLoading && !this.props.directIsLoading && this.props.addHasErrored ?
                  <span title='Error adding user to groups'>
                    <MdError size={24} color='red' />
                  </span>
                  :
                  <span></span>
                }
              </div>
          }
        </div>
      </LocalForm>;

    return (
      <div>
        {questions}
        {form}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    add: state.employee.add.add,
    addHasErrored: state.employee.add.addHasErrored,
    addIsLoading: state.employee.add.addIsLoading,
    skip: state.employee.skip.skip,
    skipHasErrored: state.employee.skip.skipHasErrored,
    skipIsLoading: state.employee.skip.skipIsLoading,
    groups: state.employee.groups.groups,
    groupsHasErrored: state.employee.groups.groupsHasErrored,
    groupsIsLoading: state.employee.groups.groupsIsLoading,
    direct: state.employee.direct.direct,
    directHasErrored: state.employee.direct.directHasErrored,
    directIsLoading: state.employee.direct.directIsLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDataAdd:    (host, params) => dispatch(addFetchData(host, params)),
    fetchDataSkip:   (host, params) => dispatch(skipFetchData(host, params)),
    fetchDataGroups: (host, params) => dispatch(groupsFetchData(host, params)),
    fetchDataDirect: (host, params) => dispatch(directFetchData(host, params))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddItem));
